import classNames from "classnames";
import styles from "./ColorSquare.module.scss";

interface ColorSquareProps {
  color?: string;
  className?: string;
  size?: "medium" | "small";
}

function ColorSquare(props: ColorSquareProps) {
  const { color, className, size = "medium" } = props;

  const rootClassName = classNames(styles.root, className, {
    [styles.medium]: size === "medium",
    [styles.small]: size === "small",
  });

  return <span className={rootClassName} style={{ background: color }}></span>;
}

export default ColorSquare;
